import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '../store'

// 解决重复点击路由报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err)
}

Vue.use(VueRouter)

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.query && to.query.m !== undefined && to.query.e !== undefined) {
    // 进入详情组件
    store.commit('setCurrentCom', 'details-view')
    store.commit('setMenu', Number(to.query.m))
    store.commit('setExhibits', Number(to.query.e))
  } else {
    // 进入首页组件
    store.commit('setCurrentCom', 'index')
    store.commit('setMenu', 0)
    store.commit('setExhibits', 0)
  }
  next()
})

export default router
